import React from "react";
import Pagenotfoundimage from "../assets/images/404_page_not_found.png"
import { Link } from "react-router-dom";
function Notfound(){
    return(
        <section className="pt-40 pb-40 page_notfound">
             <div className="container">
                  <div className="row" style={{justifyContent:'center'}}>
                      <div className="col-lg-6 col-md-8 col-sm-12">
                          <div className="inner-box">
                             <img src={Pagenotfoundimage} style={{width:'70%'}} alt="img"/>  
                             <h4 style={{color:'#374706'}}>PAGE NOT FOUND</h4> 
                             <p>The page you are looking for doesn't exist or other error occured. </p>  
                             <div className="btn_box">
                                  <Link to='/'> Go to home page</Link>
                             </div>
                          </div>
                      </div>
                  </div>
             </div>
        </section>
    )
}

export default Notfound;